/* eslint-disable jsx-a11y/anchor-is-valid */
import "./InterviewLevel.css";
import { useState, useContext, useEffect } from "react";
import axios from "axios";
import { AuthContext } from "../../../context/AuthContext";
import plusIcon from "../../../assests/plus.png";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Preview from "../../../assests/preview.png";
import Send from "../../../assests/send.png";
import { Button } from "antd";
import ViewProfile from "../ViewProfile";
import ViewProfileBack from "../ViewProfileBack";
import { Modal, Spin, Upload } from "antd";
import { ClearOutlined, CheckOutlined, UploadOutlined, DownloadOutlined } from '@ant-design/icons';


export default function InterviewLevel({ cid }) {
    const { authData, backUrl } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [sending, setSending] = useState(false);

    const [venue, setVenue] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);



    const [fileList, setFileList] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);
    const [interviewlevels, setInterviewLevels] = useState(null);
    const [organizations, setOrganizations] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [alldepartments, setAllDepartments] = useState([]);
    const [interviewerList, setInterviewerList] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [showUpdate, setShowUpdate] = useState(false);
    const [actionLoading, setActionLoading] = useState(false);
    const [candidate, setCandidate] = useState(null);

    const [allinterviewers, setAllInterviewers] = useState({});
    const [viewProfile, setViewProfile] = useState(false);

    const [data, setData] = useState({
        level_number: null,
        status: '',
        remarks: '',
    });


    const [signatureModal, setSignatureModal] = useState(false)

    // ⭐ NEW: Test Offer modal state
    const [testOfferModal, setTestOfferModal] = useState(false);
    const [testEmail, setTestEmail] = useState('');
    const [testSending, setTestSending] = useState(false);

    const [newInterview, setNewInterview] = useState({
        level_number: 1,
        organisation: '',
        department: '',
        interviewer: '',
        interview_date: '',
        interview_time: '',
        status: 'Scheduled',
        venue: 1
    });

    const [editLevelId, setEditLevelId] = useState(null);
    const [editData, setEditData] = useState({
        organisation: '',
        department: '',
        interviewer: '',
        interview_date: '',
        interview_time: '',
        venue,
        reschedule_reason: '',
    });

    useEffect(() => {
        fetchCandidate();
        fetchLevels();
        fetchOrganizations();
        fetchAllDepartments();
        fetchDesignations();
        fetchAllInterviewers();
        fetchVenue();
    }, []);


    const fetchCandidate = async () => {
        const res = await axios.get(`${backUrl}/api/emp/candidates/${cid}/`,
            { headers: { Authorization: `Bearer ${authData?.access}` } });
        setCandidate(res.data)
    }

    const fetchOrganizations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/organisations/`);
            setOrganizations(res.data.results || res.data);
        } catch (err) {
            console.error("Failed to fetch organizations:", err);
        }
    };

    const fetchVenue = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/venues/`,
                {
                    status: "Approved"
                }, {
                headers: {
                    Authorization: `Bearer ${authData?.access}`,
                },
            });
            setVenue(res.data.results || []);
        } catch (err) {
            console.error("Error fetching venues:", err);
        }
    };

    const fetchDepartments = async (id) => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/departments/?organisation=${id}`);
            setDepartments(res.data.results || res.data);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchDesignations = async (id) => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/designations/`);
            setDesignations(res.data.results || res.data);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchAllDepartments = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/departments/`);
            setAllDepartments(res.data.results || res.data);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchAllInterviewers = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/employees/`);
            setAllInterviewers(res.data.results);
        } catch (err) {
            console.error("Failed to fetch departments:", err);
        }
    };

    const fetchInterviewers = async (id) => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/employees/list_all_interviewers/?department=${id}`);
            setInterviewerList(Array.isArray(res.data.results) ? res.data.results : res.data);
        } catch (err) {
            console.error("Failed to fetch interviewers:", err);
        }
    };

    const fetchLevels = async () => {
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/candidates/all_interview_levels/?candidate_id=${cid}`,
                { headers: { Authorization: `Bearer ${authData?.access}` } }
            );
            console.log(res.data)
            setInterviewLevels(res.data);

        } catch (error) {
            console.error("Error fetching interview levels:", error);
        }
    };

    // const fetchInterviewLevel = async (lno) => {
    //     try {
    //         const res = await axios.get(
    //             `${backUrl}/api/emp/candidates/all_interview_levels/?candidate_id=${cid}/`,
    //             { headers: { Authorization: `Bearer ${authData?.access}` } }
    //         );
    //         console.log("One Interview Level",res.data)
    //         setInterviewLevel(res.data);
    //     }
    //     catch (error) {
    //         console.error("Error fetching interview levels:", error);
    //     }
    // }

    const getOrganizationName = (id) => organizations.find(o => o.id === id)?.name || "-";
    const getDepartmentName = (id) => alldepartments.find(dep => dep.id === id)?.name || "-";
    const getDesignationName = (id) => designations.find(dep => dep.id === id)?.name || "-";
    // const getInterviewerName = (id) => {
    //     const emp = interviewerList.find(emp => emp.id === id);
    //     return emp ? `${emp.first_name} ${emp.last_name || ''}` : "-";
    // };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setNewInterview({
            ...newInterview,
            [name]: name === "venue" ? parseInt(value) : value
        }); if (e.target.name === "organisation") {
            fetchDepartments(e.target.value);
        }
        if (e.target.name === "department") {
            fetchInterviewers(e.target.value);
        }
    };


    const handleUploadChange = ({ fileList: newFileList }) => {
        setFileList(newFileList);

        if (newFileList.length > 0) {
            const file = newFileList[0].originFileObj;
            const reader = new FileReader();
            reader.onload = (e) => {
                setPreviewImage(e.target.result);
            };
            reader.readAsDataURL(file);
        } else {
            setPreviewImage(null);
        }
    };

    const beforeUpload = (file) => {
        const isImage = file.type.startsWith('image/');
        if (!isImage) {
            toast.error('You can only upload image files!');
            return Upload.LIST_IGNORE;
        }

        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
            toast.error('Image must be smaller than 5MB!');
            return Upload.LIST_IGNORE;
        }

        return false; // Prevent auto upload
    };

    const handleRemove = () => {
        setFileList([]);
        setPreviewImage(null);
    };

    const handleCancel = () => {
        setFileList([]);
        setPreviewImage(null);
        setSignatureModal(false)
    };

    // ⭐ NEW: Test Offer helpers
    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleCancelTestOffer = () => {
        setTestOfferModal(false);
        setTestEmail('');
    };

    const handleSendTestOffer = async () => {
        const trimmedEmail = testEmail.trim();

        if (!trimmedEmail) {
            toast.error("Please enter an email address");
            return;
        }
        if (!isValidEmail(trimmedEmail)) {
            toast.error("Please enter a valid email address");
            return;
        }

        setTestSending(true);
        try {
            await axios.post(
                `${backUrl}/api/emp/candidates/${cid}/test-offer/`,
                { email: trimmedEmail },
                { headers: { Authorization: `Bearer ${authData?.access}` } }
            );
            toast.success(`Test offer letter sent to ${trimmedEmail}`);
            setTestOfferModal(false);
            setTestEmail('');
        } catch (error) {
            console.error("Error sending test offer:", error);

            if (error.response) {
                const backendMessage = error.response.data?.error || error.response.data?.message;
                toast.error(backendMessage || "Failed to send test offer letter");
            } else {
                toast.error("Network error. Please try again.");
            }
        } finally {
            setTestSending(false);
        }
    };


    const handleEditChange = async (e) => {
        const { name, value } = e.target;

        // Update state immediately
        setEditData({
            ...editData,
            [name]: name === "venue" ? parseInt(value) : value
        });

        try {
            if (name === "organisation") {
                await fetchDepartments(value);
            }
            if (name === "department") {
                await fetchInterviewers(value);
            }
        } catch (error) {
            console.error("Error handling change:", error);

            // Check if backend sent a response
            if (error.response) {
                const backendMessage = error.response.data?.error || error.response.data?.message || error;

                // Display exact backend error if available
                toast.error(backendMessage);

            } else {
                toast.error("Network error. Please try again.");
            }
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setActionLoading(true);
        try {
            await axios.post(
                `${backUrl}/api/emp/candidates/${cid}/schedule_interview/`,
                { candidate: cid, ...newInterview },
                { headers: { Authorization: `Bearer ${authData?.access}` } }
            );
            setShowForm(false);
            setNewInterview({
                level_number: getNextLevelNumber(),
                organisation: '',
                department: '',
                interviewer: '',
                interview_date: '',
                interview_time: '',
                status: 'Scheduled',
            });
            fetchLevels();
            toast.success("Interview level scheduled successfully");
        } catch (error) {
            console.error("Error scheduling interview level:", error);

            if (error.response) {
                if (error.response.status === 400) {
                    toast.error(error.response.data?.error || "Invalid data. Please check your input.");
                } else if (error.response.status === 404) {
                    toast.error("Candidate not found.");
                } else {
                    toast.error(error.response.data?.error || "Failed to schedule interview level");
                }
            } else {
                toast.error("Network error. Please try again.");
            }
        }
        setActionLoading(false);
    };

    const handleUpdate = async () => {
        setActionLoading(true);
        try {

            await axios.put(
                `${backUrl}/api/emp/candidates/${cid}/schedule_interview/`,
                editData,
                { headers: { Authorization: `Bearer ${authData?.access}` } }
            );
            console.log("editData", editData)
            setEditLevelId(null);

            fetchLevels();
            toast.success("Interview level updated successfully");
        } catch (error) {
            console.error("Error handling change:", error);

            // Check if backend sent a response
            if (error.response) {
                const backendMessage = error.response.data?.error || error.response.data?.message || error;

                // Display exact backend error if available
                toast.error(backendMessage);

            } else {
                toast.error("Network error. Please try again.");
            }
        }
        setActionLoading(false);
    };

    const handleSubmitChange = async (l_no) => {
        try {
            const updatedData = { ...data, level_number: l_no };

            const res = await axios.put(
                `${backUrl}/api/emp/candidates/${cid}/hod_review/`,
                updatedData,
                { headers: { Authorization: `Bearer ${authData?.access}` } }
            );

            console.log(res.data);
            setShowUpdate(false);
            setEditLevelId(null);
            setData({});
        } catch (err) {
            console.error("Failed to change status:", err);
        }
    };

    const getNextLevelNumber = () => {
        const levels = interviewlevels?.interview_levels || [];
        if (levels.length === 0) return 1;
        const levelNumbers = levels.map(level => level.level_number);
        return Math.max(...levelNumbers) + 1;
    };

    const handleDownloadSchedulePdf = async () => {
        try {
            const response = await axios.get(
                `${backUrl}/api/emp/candidates/${cid}/download-interview-schedule/`,
                {
                    headers: { Authorization: `Bearer ${authData?.access}` },
                    responseType: 'blob'
                }
            );

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Interview_Schedule_${interviewlevels?.candidate_name || cid}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            toast.success("Interview schedule PDF downloaded successfully!");
        } catch (error) {
            console.error("Error downloading interview schedule PDF:", error);
            let errorMsg = "Failed to download interview schedule PDF.";
            if (error.response?.data instanceof Blob) {
                try {
                    const text = await error.response.data.text();
                    try {
                        const json = JSON.parse(text);
                        if (json.error) errorMsg = json.error;
                    } catch (e) {
                        if (text && text.length < 200) errorMsg = text;
                    }
                } catch (e) { }
            } else if (error.response?.data?.error) {
                errorMsg = error.response.data.error;
            }
            toast.error(errorMsg);
        }
    };



    if (!interviewlevels) return <p>Loading interview details...</p>;

    const handleViewProfile = () => {
        setViewProfile(!viewProfile);
    }

    const handleClick = async () => {
        const confirmed = window.confirm("Are you sure you want to send the offer?");
        if (!confirmed) return;

        setLoading(true);
        try {
            await axios.post(`${backUrl}/api/emp/send-offer/${cid}/`);
            fetchCandidate();
        } catch (err) {
            console.error("Error sending offer:", err);
        } finally {
            setLoading(false);
        }
    };


    return (

        <>
            {
                viewProfile ? (
                    <ViewProfile candidateid={cid} />
                ) : (
                    <>
                        <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <center><h5>Interview Status of {interviewlevels.candidate_name}</h5></center>
                            <div className="d-flex gap-2">
                                <Button
                                    type="primary"
                                    icon={<DownloadOutlined />}
                                    style={{ backgroundColor: '#0e497b', borderColor: '#0e497b' }}
                                    onClick={handleDownloadSchedulePdf}
                                >
                                    Download Schedule PDF
                                </Button>
                                <button
                                    type="button"
                                    className="btn btn-outline-primary d-flex align-items-center"
                                    onClick={() => {
                                        setNewInterview(prev => ({
                                            ...prev,
                                            level_number: getNextLevelNumber(),
                                        }));
                                        setShowForm(true);
                                    }}
                                >
                                    <img src={plusIcon} alt="Add" style={{ width: "20px", height: "20px" }} className="me-2" />
                                    Add Level
                                </button>
                            </div>
                        </div>

                        {interviewlevels.interview_levels.length > 0 ? (
                            interviewlevels.interview_levels.map((level) => (
                                <div key={level.id} className="interview-level-card border p-3 mb-3 rounded">
                                    <h5>Interview Response from Candidate : {level.candidate_status}</h5>
                                    {
                                        level.rejection_reason && (
                                            <span style={{ color: 'red' }}>Reason : {level.rejection_reason}</span>
                                        )
                                    }
                                    {
                                        editLevelId === level.id ? (
                                            <>
                                                <div className="row">
                                                    <div className="col-md-4 mb-2">
                                                        <label>Level</label>
                                                        <input
                                                            type="text"
                                                            value={level.level_number}
                                                            name="level_number"
                                                            readOnly
                                                            className="form-control"
                                                        />
                                                    </div>
                                                    <div className="col-md-4 mb-2">
                                                        <label>Organisation</label>
                                                        <select
                                                            name="organisation"
                                                            className="form-control"
                                                            value={editData.organisation ? editData.organisation : ""}
                                                            onChange={handleEditChange}
                                                        >
                                                            <option value="">--Select--</option>

                                                            {organizations.map((org) => (
                                                                <option key={org.id} value={org.id}>
                                                                    {org.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="col-md-4 mb-2">
                                                        <label>Department</label>
                                                        <select
                                                            name="department"
                                                            className="form-control"
                                                            value={editData.department || ""}
                                                            onChange={handleEditChange}
                                                        >
                                                            <option value="">--Select--</option>
                                                            {departments.map((dep) => (
                                                                <option key={dep.id} value={dep.id}>
                                                                    {dep.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-4 mb-2">
                                                        <label>Interviewer</label>
                                                        <select
                                                            name="interviewer"
                                                            className="form-control"
                                                            value={editData.interviewer || ""}
                                                            onChange={handleEditChange}
                                                        >
                                                            <option value="">--Select--</option>
                                                            {interviewerList.map((emp) => (
                                                                <option key={emp.id} value={emp.id}>
                                                                    {emp.first_name} - {getDesignationName(emp.designation)}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="col-md-4 mb-2">
                                                        <label>Date</label>
                                                        <input
                                                            type="date"
                                                            name="interview_date"
                                                            className="form-control"
                                                            value={editData.interview_date || ""}
                                                            onChange={handleEditChange}
                                                        />
                                                    </div>
                                                    <div className="col-md-4 mb-2">
                                                        <label>Time</label>
                                                        <input
                                                            type="time"
                                                            name="interview_time"
                                                            className="form-control"
                                                            value={editData.interview_time || ""}
                                                            onChange={handleEditChange}
                                                        />
                                                    </div>
                                                    <div className="col-md-4 mb-2">
                                                        <label>Venue</label>
                                                        <select
                                                            name="venue"
                                                            className="form-control"
                                                            value={editData.venue || ""}
                                                            onChange={handleEditChange}
                                                        >
                                                            <option value="">--Select--</option>
                                                            {venue.map((v) => (
                                                                <option key={v.id} value={v.id}>
                                                                    {v.venue}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>

                                                    <div className="col-md-4 mb-2">
                                                        <label>Reschedule Reason</label>
                                                        <select
                                                            name="reschedule_reason"
                                                            className="form-control"
                                                            value={editData.reschedule_reason || ""}
                                                            onChange={handleEditChange}
                                                        >
                                                            <option value="">--Select--</option>
                                                            <option value="INTERVIEWER_UNAVAILABLE">Interviewer Unavailable</option>
                                                            <option value="CANDIDATE_REQUEST">Candidate Request</option>

                                                        </select>
                                                    </div>
                                                    {/* <div className="col-md-4 mb-2">
                                                        <label>Status</label>
                                                        <select
                                                            name="status"
                                                            className="form-control"
                                                            value={editData.status || ""}
                                                            onChange={handleEditChange}
                                                        >
                                                            <option value="">--Select--</option>
                                                            <option value="Scheduled">Scheduled</option>
                                                            <option value="Shortlisted">Shortlisted</option>
                                                            <option value="Rejected">Rejected</option>
                                                            <option value="In-hold">In-hold</option>
                                                        </select>
                                                    </div> */}
                                                </div>

                                                <button
                                                    className="btn btn-secondary me-2"
                                                    onClick={handleUpdate}
                                                    disabled={actionLoading}
                                                >
                                                    {actionLoading ? "Updating..." : "Update"}
                                                </button>
                                                <button
                                                    className="btn btn-secondary me-2"
                                                    onClick={() => setEditLevelId(null)}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    className="btn btn-success me-2"
                                                    onClick={() => setShowUpdate(!showUpdate)}
                                                >
                                                    Change Status
                                                </button>
                                                <button
                                                    className="btn btn-danger me-2"
                                                    onClick={() => { }}
                                                >
                                                    Decline Interview
                                                </button>

                                                {showUpdate && (
                                                    <div className="status-update-container p-4 rounded shadow-sm bg-light mt-4">
                                                        <center>
                                                            <div className="mb-3">
                                                                <button
                                                                    className={`btn ${data.status === "Shortlisted"
                                                                        ? "btn-success"
                                                                        : "btn-outline-success"
                                                                        } mx-2`}
                                                                    onClick={() => setData({ ...data, status: "Shortlisted" })}
                                                                >
                                                                    Shortlisted
                                                                </button>
                                                                <button
                                                                    className={`btn ${data.status === "Rejected" ? "btn-danger" : "btn-outline-danger"
                                                                        } mx-2`}
                                                                    onClick={() => setData({ ...data, status: "Rejected" })}
                                                                >
                                                                    Rejected
                                                                </button>
                                                                <button
                                                                    className={`btn ${data.status === "On-hold"
                                                                        ? "btn-secondary"
                                                                        : "btn-outline-secondary"
                                                                        } mx-2`}
                                                                    onClick={() => setData({ ...data, status: "On-hold" })}
                                                                >
                                                                    Hold
                                                                </button>
                                                            </div>
                                                        </center>
                                                        <center>
                                                            <Button
                                                                style={{ backgroundColor: "#0e497b", color: "white" }}
                                                                onClick={() => handleSubmitChange(level.level_number)}
                                                            >
                                                                Submit
                                                            </Button>
                                                        </center>
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                <section className="d-flex justify-content-between p-4" >
                                                    <div>
                                                        <p><strong>Level:</strong> {level.level_number}</p>
                                                        <p><strong>Organisation:</strong> {getOrganizationName(level.organisation)}</p>
                                                        <p><strong>Department:</strong> {getDepartmentName(level.department)}</p>
                                                        <p><strong>Interviewer:</strong> {level.interviewer_name}</p>
                                                        <p><strong>Date:</strong> {level.interview_date}</p>
                                                        <p><strong>Time:</strong> {level.interview_time}</p>
                                                        <p><strong>Venue:</strong> {level.venue_name}</p>
                                                        <p><strong>Status: </strong> {level.status}</p>
                                                        {
                                                            level.remarks && (
                                                                <p><strong>Comments:</strong> {level.remarks}</p>
                                                            )
                                                        }
                                                    </div>
                                                    <div style={{ paddingRight: '150px' }}>
                                                        {
                                                            level.tech_qualification ? (
                                                                <p><strong>Qualification: </strong> {level.tech_qualification}</p>
                                                            ) : (
                                                                <p><strong>Qualification: </strong> No Data</p>

                                                            )
                                                        }
                                                        {
                                                            level.tech_experience ? (
                                                                <p><strong>Experience: </strong> {level.tech_experience}</p>
                                                            ) : (
                                                                <p><strong>Experience: </strong> No Data</p>

                                                            )
                                                        }
                                                        {
                                                            level.tech_knowledge ? (
                                                                <p><strong>Knowledge: </strong> {level.tech_knowledge}</p>
                                                            ) : (
                                                                <p><strong>Knowledge: </strong> No Data</p>

                                                            )
                                                        }
                                                        {
                                                            level.tech_skills_rating ? (
                                                                <p><strong>Skills: </strong> {level.tech_skills_rating}</p>
                                                            ) : (
                                                                <p><strong>Skills: </strong> No Data</p>

                                                            )
                                                        }
                                                        {
                                                            level.tech_attitude ? (
                                                                <p><strong>Attitude: </strong> {level.tech_attitude}</p>
                                                            ) : (

                                                                <p><strong>Attitude: </strong> No Data</p>
                                                            )
                                                        }
                                                        {
                                                            level.tech_communication ? (
                                                                <p><strong>Communication: </strong> {level.tech_communication}</p>
                                                            ) : (
                                                                <p><strong>Communication: </strong> No Data</p>

                                                            )
                                                        }
                                                        {
                                                            level.tech_time_management ? (
                                                                <p><strong>Time Management: </strong> {level.tech_time_management}</p>
                                                            ) : (

                                                                <p><strong>Time Management: </strong> No Data</p>
                                                            )
                                                        }
                                                        {
                                                            level.tech_flexibility ? (
                                                                <p><strong>Flexibility: </strong> {level.tech_flexibility}</p>
                                                            ) : (
                                                                <p><strong>Flexibility: </strong> No Data</p>

                                                            )
                                                        }
                                                        {
                                                            level.tech_commitment ? (
                                                                <p><strong>Commitment: </strong> {level.tech_commitment}</p>
                                                            ) : (
                                                                <p><strong>Commitment: </strong> No Data</p>

                                                            )
                                                        }


                                                    </div>

                                                </section>



                                                {
                                                    (level.status === "Shortlisted" || level.status === "Selected") ? (
                                                        <></>

                                                    ) : (
                                                        <>
                                                            <button
                                                                className="btn btn-outline-secondary btn-sm"
                                                                onClick={async () => {
                                                                    setEditLevelId(level.id);
                                                                    setEditData({
                                                                        level_number: level.level_number,
                                                                        organisation: level.organisation,
                                                                        department: level.department,
                                                                        interviewer: level.interviewer,
                                                                        interview_date: level.interview_date,
                                                                        interview_time: level.interview_time,
                                                                        venue: level.venue,
                                                                        reschedule_reason: level.reschedule_reason || ''
                                                                    });
                                                                    setData({
                                                                        status: level.status,
                                                                        remarks: level.remarks
                                                                    });

                                                                    // ⭐ NEW: preload dependent dropdown options so values map immediately
                                                                    if (level.organisation) {
                                                                        await fetchDepartments(level.organisation);
                                                                    }
                                                                    if (level.department) {
                                                                        await fetchInterviewers(level.department);
                                                                    }
                                                                }}
                                                            >
                                                                Edit
                                                            </button>
                                                        </>

                                                    )
                                                }


                                                {level.status === "Selected" && candidate && (
                                                    <>
                                                        {
                                                            candidate.offerletter_triggered === true && (
                                                                <>
                                                                    <center>
                                                                        <p className="text-dark">Offer Letter Sent to the candidate</p>
                                                                    </center>
                                                                </>
                                                            )
                                                        }

                                                        {candidate.offerletter_triggered === true ? (
                                                            candidate.offerletter_status === "ACCEPTED" ? (
                                                                <center>
                                                                    <h5 className="text-success">Offer Letter Accepted by the candidate</h5>
                                                                    <p>Remarks : {candidate.offer_letter_remarks}</p>
                                                                    {
                                                                        candidate.onboarding_status === "Completed" ? (
                                                                            <>
                                                                                <p>Onboarding Form Submitted</p>
                                                                                {
                                                                                    authData.employee.is_superuser ? (
                                                                                        <>
                                                                                            <div className="d-flex justify-content-center align-center">
                                                                                                <button className="text-light p-2" onClick={handleViewProfile}>
                                                                                                    View Profile
                                                                                                </button>
                                                                                            </div>
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            <div>
                                                                                                {authData.employee.role === 1 && (
                                                                                                    <div className="d-flex justify-content-center align-center">
                                                                                                        <button className="text-light p-2" onClick={handleViewProfile}>
                                                                                                            View Profile
                                                                                                        </button>
                                                                                                    </div>
                                                                                                )}

                                                                                                {authData.employee.role === 2 && (
                                                                                                    <div className="d-flex justify-content-center align-center">
                                                                                                        <button className="text-light p-2" onClick={handleViewProfile}>
                                                                                                            View Profile
                                                                                                        </button>
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>

                                                                                        </>
                                                                                    )
                                                                                }
                                                                            </>
                                                                        ) : (
                                                                            <>

                                                                                {
                                                                                    candidate.onboarding_trigger === true ? (
                                                                                        <>
                                                                                            <center>
                                                                                                <p className="text-dark">Onboarding Form Sent to the candidate</p>
                                                                                            </center>

                                                                                        </>
                                                                                    ) : (
                                                                                        <a
                                                                                            id="bread"
                                                                                            className="ms-5"
                                                                                            role="button"
                                                                                            onClick={async () => {
                                                                                                try {
                                                                                                    setSending(true); // start loader
                                                                                                    const updatedCandidate = { ...candidate, onboarding_trigger: true };
                                                                                                    setCandidate(updatedCandidate);

                                                                                                    await axios.post(
                                                                                                        `${backUrl}/api/emp/candidatespreonboarding/${cid}/send_preonboarding_link/`,
                                                                                                        updatedCandidate,
                                                                                                        {
                                                                                                            headers: { Authorization: `Bearer ${authData?.access}` },
                                                                                                        }
                                                                                                    );

                                                                                                    toast.success("Pre-Onboarding link sent successfully!");
                                                                                                } catch (error) {
                                                                                                    console.error("Error sending link:", error);
                                                                                                    toast.error("Failed to send Pre-Onboarding link.");
                                                                                                } finally {
                                                                                                    setSending(false); // stop loader
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            {sending ? (
                                                                                                <Spin size="small" style={{ marginRight: 8 }} />
                                                                                            ) : (
                                                                                                <img src={Send} alt="Send" className="icon" />
                                                                                            )}
                                                                                            Send Pre-Onboarding Form
                                                                                        </a>
                                                                                    )
                                                                                }
                                                                            </>
                                                                        )
                                                                    }

                                                                </center>
                                                            ) : candidate.offerletter_status === "DECLINED" ? (
                                                                <center>
                                                                    <h5 className="text-danger">Offer Letter Declined by the candidate</h5>
                                                                    <p>Remarks : {candidate.offer_letter_remarks}</p>
                                                                    <a
                                                                        id="bread"
                                                                        className="ms-5"
                                                                        onClick={handleClick}
                                                                        style={{ cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.6 : 1 }}
                                                                    >
                                                                        {loading ? (
                                                                            <Spin size="small" />
                                                                        ) : (
                                                                            <>
                                                                                Resend <img src={Send} alt="img" className="icon" />
                                                                            </>
                                                                        )}
                                                                    </a>
                                                                </center>
                                                            ) : null
                                                        ) : (

                                                            <center id="offer-sction">
                                                                {
                                                                    signatureModal && (
                                                                        <>
                                                                            <Modal
                                                                                onCancel={handleCancel}
                                                                                width={500}
                                                                                open={signatureModal}
                                                                                footer={[
                                                                                    <Button key="cancel" onClick={handleCancel}>
                                                                                        Cancel
                                                                                    </Button>,
                                                                                    <Button
                                                                                        key="save"
                                                                                        type="primary"
                                                                                        loading={isSubmitting}
                                                                                        disabled={isSubmitting || !previewImage}
                                                                                        onClick={async () => {
                                                                                            try {
                                                                                                setIsSubmitting(true);

                                                                                                const formData = new FormData();

                                                                                                // Handle image conversion
                                                                                                if (fileList.length > 0 && fileList[0].originFileObj) {
                                                                                                    formData.append("signature_image", fileList[0].originFileObj);
                                                                                                } else if (previewImage) {
                                                                                                    const base64Response = await fetch(previewImage);
                                                                                                    const blob = await base64Response.blob();
                                                                                                    formData.append("signature_image", blob, "signature.png");
                                                                                                }

                                                                                                const response = await axios.post(
                                                                                                    `${backUrl}/api/emp/preview-offer/${cid}/`,
                                                                                                    formData,
                                                                                                    {
                                                                                                        headers: {
                                                                                                            Authorization: `Bearer ${authData.access}`,
                                                                                                        },
                                                                                                        responseType: 'blob',
                                                                                                        timeout: 30000
                                                                                                    }
                                                                                                );

                                                                                                // Check if response is valid
                                                                                                if (!response.data || response.data.size === 0) {
                                                                                                    throw new Error('Received empty document');
                                                                                                }

                                                                                                // Get content type
                                                                                                const contentType = response.headers['content-type'] || response.data.type;

                                                                                                let fileExtension = 'pdf';
                                                                                                let mimeType = 'application/pdf';
                                                                                                let fileName = `Offer_Letter_${cid}`;

                                                                                                // Check if it's a Word document
                                                                                                if (contentType.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document') ||
                                                                                                    contentType.includes('application/msword')) {
                                                                                                    fileExtension = 'docx';
                                                                                                    mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                                                                                                    fileName = `Offer_Letter_${cid}.docx`;

                                                                                                    // For Word documents, we need to download instead of preview
                                                                                                    const blob = new Blob([response.data], { type: mimeType });
                                                                                                    const downloadUrl = URL.createObjectURL(blob);

                                                                                                    const downloadLink = document.createElement('a');
                                                                                                    downloadLink.href = downloadUrl;
                                                                                                    downloadLink.download = fileName;
                                                                                                    document.body.appendChild(downloadLink);
                                                                                                    downloadLink.click();
                                                                                                    document.body.removeChild(downloadLink);

                                                                                                    // Clean up
                                                                                                    setTimeout(() => URL.revokeObjectURL(downloadUrl), 5000);

                                                                                                    toast.success("Offer letter downloaded successfully! Please open the file to view.");

                                                                                                } else if (contentType.includes('application/pdf')) {
                                                                                                    // Handle PDF preview
                                                                                                    const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
                                                                                                    const pdfUrl = URL.createObjectURL(pdfBlob);

                                                                                                    const newWindow = window.open(pdfUrl, '_blank');

                                                                                                    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
                                                                                                        // Popup blocked - download
                                                                                                        const downloadLink = document.createElement('a');
                                                                                                        downloadLink.href = pdfUrl;
                                                                                                        downloadLink.download = `${fileName}.pdf`;
                                                                                                        document.body.appendChild(downloadLink);
                                                                                                        downloadLink.click();
                                                                                                        document.body.removeChild(downloadLink);

                                                                                                        toast.info("Popup blocked. PDF has been downloaded.");
                                                                                                    } else {
                                                                                                        toast.success("Offer letter preview opened in new tab!");
                                                                                                    }

                                                                                                    setTimeout(() => URL.revokeObjectURL(pdfUrl), 120000);
                                                                                                } else {
                                                                                                    // Unknown format - download anyway
                                                                                                    const blob = new Blob([response.data], { type: contentType });
                                                                                                    const downloadUrl = URL.createObjectURL(blob);

                                                                                                    const downloadLink = document.createElement('a');
                                                                                                    downloadLink.href = downloadUrl;
                                                                                                    downloadLink.download = `Offer_Letter_${cid}`;
                                                                                                    document.body.appendChild(downloadLink);
                                                                                                    downloadLink.click();
                                                                                                    document.body.removeChild(downloadLink);

                                                                                                    setTimeout(() => URL.revokeObjectURL(downloadUrl), 5000);

                                                                                                    toast.success("Offer letter downloaded successfully!");
                                                                                                }

                                                                                                // Close modal and reset form
                                                                                                setTimeout(() => {
                                                                                                    setSignatureModal(false);
                                                                                                    setFileList([]);
                                                                                                    setPreviewImage(null);
                                                                                                }, 800);

                                                                                            } catch (err) {
                                                                                                console.error("Error generating offer letter:", err);

                                                                                                if (err.code === 'ECONNABORTED' || err.message.includes('timeout')) {
                                                                                                    toast.error("Request timed out. Please try again.");
                                                                                                } else if (err.response) {
                                                                                                    const status = err.response.status;
                                                                                                    const errorData = err.response.data;

                                                                                                    if (errorData instanceof Blob) {
                                                                                                        const reader = new FileReader();
                                                                                                        reader.onload = () => {
                                                                                                            try {
                                                                                                                const errorJson = JSON.parse(reader.result);
                                                                                                                toast.error(errorJson.error || errorJson.message || "Failed to generate offer letter");
                                                                                                            } catch {
                                                                                                                toast.error("Failed to generate offer letter. Please try again.");
                                                                                                            }
                                                                                                        };
                                                                                                        reader.readAsText(errorData);
                                                                                                    } else {
                                                                                                        switch (status) {
                                                                                                            case 400:
                                                                                                                toast.error(errorData?.error || "Invalid signature image or data.");
                                                                                                                break;
                                                                                                            case 404:
                                                                                                                toast.error("Candidate or offer template not found.");
                                                                                                                break;
                                                                                                            case 500:
                                                                                                                toast.error("Server error. Please contact support.");
                                                                                                                break;
                                                                                                            default:
                                                                                                                toast.error(errorData?.error || "Failed to generate offer letter.");
                                                                                                        }
                                                                                                    }
                                                                                                } else if (err.request) {
                                                                                                    toast.error("Network error. Please check your connection.");
                                                                                                } else {
                                                                                                    toast.error(err.message || "Failed to generate offer letter");
                                                                                                }
                                                                                            } finally {
                                                                                                setIsSubmitting(false);
                                                                                            }
                                                                                        }}
                                                                                        style={{ background: '#0e497b', color: '#ffffff' }}
                                                                                    >
                                                                                        {isSubmitting ? 'Generating...' : 'Generate & Download'}
                                                                                    </Button>,
                                                                                ]}
                                                                            >
                                                                                <div style={{ padding: '20px' }}>
                                                                                    <h6 style={{ marginBottom: '15px', color: '#0e497b' }}>
                                                                                        Upload Your Signature
                                                                                    </h6>
                                                                                    <p style={{ fontSize: '12px', color: '#666', marginBottom: '15px' }}>
                                                                                        Please upload a clear signature image (PNG, JPG, or JPEG, max 5MB)
                                                                                    </p>

                                                                                    <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                                                                                        <Upload
                                                                                            listType="picture-card"
                                                                                            fileList={fileList}
                                                                                            onChange={handleUploadChange}
                                                                                            beforeUpload={beforeUpload}
                                                                                            maxCount={1}
                                                                                            accept="image/*"
                                                                                            onRemove={handleRemove}
                                                                                            style={{ marginBottom: '15px' }}
                                                                                        >
                                                                                            {fileList.length === 0 && (
                                                                                                <div>
                                                                                                    <UploadOutlined style={{ fontSize: '32px', color: '#0e497b' }} />
                                                                                                    <p style={{ fontSize: '12px', marginTop: '8px' }}>Upload Signature</p>
                                                                                                </div>
                                                                                            )}
                                                                                        </Upload>

                                                                                        {previewImage && (
                                                                                            <div
                                                                                                style={{
                                                                                                    marginTop: '20px',
                                                                                                    padding: '16px',
                                                                                                    border: '2px solid #e8e8e8',
                                                                                                    borderRadius: '8px',
                                                                                                    backgroundColor: '#fafafa',
                                                                                                    width: '100%',
                                                                                                    maxWidth: '300px'
                                                                                                }}
                                                                                            >
                                                                                                <p style={{ fontSize: '12px', marginBottom: '10px', color: '#666', textAlign: 'center' }}>
                                                                                                    Signature Preview
                                                                                                </p>
                                                                                                <img
                                                                                                    src={previewImage}
                                                                                                    alt="Signature Preview"
                                                                                                    style={{
                                                                                                        width: '100%',
                                                                                                        maxHeight: '150px',
                                                                                                        objectFit: 'contain',
                                                                                                        border: '1px solid #d9d9d9',
                                                                                                        borderRadius: '4px',
                                                                                                        backgroundColor: '#fff',
                                                                                                        padding: '8px'
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        )}

                                                                                        {!previewImage && (
                                                                                            <p style={{ fontSize: '11px', color: '#ff4d4f', marginTop: '10px', textAlign: 'center' }}>
                                                                                                * Signature is required to generate offer letter
                                                                                            </p>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </Modal>
                                                                        </>
                                                                    )
                                                                }

                                                                {/* ⭐ NEW: Test Offer modal */}
                                                                {
                                                                    testOfferModal && (
                                                                        <Modal
                                                                            title="Send Test Offer Letter"
                                                                            open={testOfferModal}
                                                                            onCancel={handleCancelTestOffer}
                                                                            footer={[
                                                                                <Button key="cancel" onClick={handleCancelTestOffer}>
                                                                                    Cancel
                                                                                </Button>,
                                                                                <Button
                                                                                    key="send"
                                                                                    type="primary"
                                                                                    loading={testSending}
                                                                                    disabled={testSending || !testEmail.trim()}
                                                                                    style={{ background: '#0e497b', borderColor: '#0e497b', color: '#ffffff' }}
                                                                                    onClick={handleSendTestOffer}
                                                                                >
                                                                                    {testSending ? "Sending..." : "Send Test Offer"}
                                                                                </Button>,
                                                                            ]}
                                                                        >
                                                                            <p style={{ fontSize: '12px', color: '#666', marginBottom: '10px' }}>
                                                                                This will send a test copy of the offer letter to the email address below only.
                                                                                It will not mark the offer as sent to the candidate.
                                                                            </p>
                                                                            <input
                                                                                type="email"
                                                                                className="form-control"
                                                                                placeholder="Enter email address"
                                                                                value={testEmail}
                                                                                onChange={(e) => setTestEmail(e.target.value)}
                                                                                onKeyDown={(e) => {
                                                                                    if (e.key === 'Enter') {
                                                                                        e.preventDefault();
                                                                                        handleSendTestOffer();
                                                                                    }
                                                                                }}
                                                                            />
                                                                        </Modal>
                                                                    )
                                                                }

                                                                <h5 className="mb-3">Offer Letter</h5>
                                                                <a id="bread" onClick={() => setSignatureModal(!signatureModal)}>
                                                                    <img src={Preview} alt="img" className="icon" /> Preview
                                                                </a>
                                                                <a
                                                                    id="bread"
                                                                    className="ms-3"
                                                                    role="button"
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => setTestOfferModal(true)}
                                                                >
                                                                    Test Offer
                                                                </a>
                                                                <a
                                                                    id="bread"
                                                                    className="ms-5"
                                                                    onClick={handleClick}
                                                                    style={{ cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.6 : 1 }}
                                                                >
                                                                    {loading ? (
                                                                        <Spin size="small" />
                                                                    ) : (
                                                                        <>
                                                                            Send <img src={Send} alt="img" className="icon" />
                                                                        </>
                                                                    )}
                                                                </a>
                                                            </center>
                                                        )}
                                                    </>
                                                )}
                                            </>
                                        )}
                                </div >
                            ))
                        ) : (
                            <p>No interview levels found.</p>
                        )
                        }

                        {
                            showForm && (
                                <form onSubmit={handleSubmit} className="p-4 border rounded mt-4 bg-light">
                                    <h5>Schedule New Interview Level</h5>
                                    <div className="mb-2">
                                        <label>Level Number</label>
                                        <input type="number" name="level_number" className="form-control" required value={newInterview.level_number} onChange={handleChange} readOnly />
                                    </div>
                                    <div className="mb-2">
                                        <label>Organisation</label>
                                        <select name="organisation" className="form-control" required value={newInterview.organisation} onChange={handleChange}>
                                            <option value="">--Select--</option>
                                            {organizations.map(org => (
                                                <option key={org.id} value={org.id}>{org.name}</option>
                                            ))

                                            }
                                        </select>
                                    </div>
                                    <div className="mb-2">
                                        <label>Department</label>
                                        <select name="department" className="form-control" required value={newInterview.department} onChange={handleChange}>
                                            <option value="">--Select--</option>
                                            {departments.map(dep => (
                                                <option key={dep.id} value={dep.id}>{dep.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="mb-2">
                                        <label>Interviewer</label>
                                        <select name="interviewer" className="form-control" required value={newInterview.interviewer} onChange={handleChange}>
                                            <option value="">--Select--</option>
                                            {interviewerList.map(emp => (
                                                <option key={emp.id} value={emp.id}>
                                                    {emp.first_name} - {getDesignationName(emp.designation)}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="mb-2">
                                        <label>Date</label>
                                        <input type="date" name="interview_date" className="form-control" required value={newInterview.interview_date} onChange={handleChange} />
                                    </div>
                                    <div className="mb-2">
                                        <label>Time</label>
                                        <input type="time" name="interview_time" className="form-control" required value={newInterview.interview_time} onChange={handleChange} />
                                    </div>
                                    <div className="mb-2">
                                        <label>Venue</label>
                                        <select name="venue" className="form-control" required value={newInterview.venue} onChange={handleChange}>
                                            <option value="">--Select--</option>
                                            {venue.map(v => (
                                                <option key={v.id} value={v.id}>
                                                    {v.venue}
                                                </option>
                                            ))}
                                        </select>                                    </div>
                                    <button type="submit" className="btn btn-success mt-2" disabled={actionLoading}>
                                        {actionLoading ? "Scheduling..." : "Schedule"}
                                    </button>
                                </form>

                            )
                        }
                    </>
                )
            }

        </>
    );
}